export enum AppFeatureId{
  CONFIDENTIAL_FEATURE_ID = 2,
  PROJECT_BOUND_TRANSACTION_VISIBILITY_ID = 3,
  MEMORIZE_ACCOUNT_BY_DESCRIPTION = 4,
  MEMORIZE_ITEM_BY_DESCRIPTION = 5,
  MEMORIZE_ACCOUNT_BY_MERCHANT = 6,
  ENABLE_DEPARTMENT_ADDRESS_INTO_PO = 28
}
